import { MarkOptional } from 'ts-essentials';

import { humanCase } from '@dotfile/shared/common';
import { CHECK_ANALYSIS_RESULT_KEY_SEPARATOR } from '@dotfile/shared/domain';

import { AnalysisResult } from '../types';

/**
 * Cosmetic, uppercase some tokens
 * eg: Mrz -> MRZ
 */
const upperCaseToken = (
  label: string,
  tokens = ['mrz', 'id', 'ocr', 'bic', 'iban'],
) => {
  const tokenRegExp = new RegExp(`(^|.*\\s)(${tokens.join('|')})\\s?(.*)`, 'i');
  const parts = label.match(tokenRegExp);
  if (parts?.length) {
    const [_fullMatch, start, toUpperCase, ...rest] = parts;
    void _fullMatch; // unused

    return [start, toUpperCase.toUpperCase(), ...rest].join(' ');
  }

  return label;
};

const extractUnit = (suffix: string) => {
  const parts = suffix.split('_');

  const hasMoreThan2Parts = parts.length > 2;
  const [secondLastPart, lastPart] = parts.slice(-2);
  const secondLastPartIsIn = secondLastPart === 'in';

  if (hasMoreThan2Parts && secondLastPartIsIn) {
    return lastPart;
  }

  return undefined;
};

export const buildAnalysisResultLabel = ({
  key,
}: MarkOptional<AnalysisResult, 'translation'>): {
  label: string;
  unit?: string;
} => {
  const parts = key.split(CHECK_ANALYSIS_RESULT_KEY_SEPARATOR);

  let suffix = parts[parts.length - 1];
  const unit = extractUnit(suffix);
  if (unit) {
    suffix = suffix.split('_').slice(0, -2).join('_');
  }

  const label = upperCaseToken(humanCase(suffix));

  return { label, unit };
};
